import { gql } from "@apollo/client";

export default gql`
  mutation saveFellowIntegration(
    $organizationId: Int!
    $fellowApiKey: String
    $fellowApiDomain: String
    $fellowTranscriptSyncEnabled: Boolean
  ) {
    createOrUpdateOrganization(
      organizationId: $organizationId
      fellowApiKey: $fellowApiKey
      fellowApiDomain: $fellowApiDomain
      fellowTranscriptSyncEnabled: $fellowTranscriptSyncEnabled
    ) {
      organization {
        id
        hasFellowTranscriptSyncConnection
        fellowApiDomain
      }
    }
  }
`;
